<script>
import numeral from 'numeral'
import { toThaiDatetime } from '@/utils/datetime'

const DataTable = () => import('../sell/DataTable_bk.vue')

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('change', { ...this.data, [key]: value })
    }
  },

  render() {
    const Info = ({ slots }) => [
      slots().header && (
        <div style={{ marginBottom: '1rem' }}>{slots().header}</div>
      ),
      <el-form labelWidth="6rem">
        <el-row type="flex" gutter={32} style={{ flexWrap: 'wrap' }}>
          <el-col sm={12}>
            <el-form-item label="Invoice ID:">
              {this.data.invoiceId}
            </el-form-item>
          </el-col>
          <el-col sm={12}>
            <el-form-item label="น้ำหนักทอง:">
              <span style={{ fontWeight: 'bold' }}>
                {numeral(this.data.realWeight).format('0,0.00')} กรัม
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" gutter={32} style={{ flexWrap: 'wrap' }}>
          <el-col sm={12}>
            <el-form-item label="วันที่โอน:">
              {toThaiDatetime(this.data.datetime, 'D MMMM Y H:mm น.')}
            </el-form-item>
          </el-col>
          <el-col sm={12}>
            <el-form-item label="ผู้โอน:">{this.data.transferor}</el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" gutter={32} style={{ flexWrap: 'wrap' }}>
          <el-col sm={12}>
            <el-form-item label="ร้านค้าส่ง:">{this.data.store}</el-form-item>
          </el-col>
          <el-col sm={12}>
            <el-form-item label="ผู้ขนส่ง:">{this.data.carrier}</el-form-item>
          </el-col>
        </el-row>
      </el-form>,
      slots().default
    ]

    const Note = () => (
      <el-card style={{ marginTop: '1.5rem' }}>
        <el-form labelPosition="top">
          <el-form-item label="หมายเหตุ">
            {this.readonly ? (
              <div style={{ lineHeight: '1.5' }}>{this.data.note}</div>
            ) : (
              <el-input
                value={this.data.note}
                type="textarea"
                autosize={{ minRows: 3 }}
                onInput={value => {
                  this.emit('note', value)
                }}
              />
            )}
          </el-form-item>
        </el-form>
      </el-card>
    )

    return (
      <div>
        <el-card>
          <Info>
            <template slot="header">{this.$slots.header}</template>
            {this.readonly && (
              <DataTable
                data={this.data.items}
                readonly
                style={{ marginTop: '1.5rem' }}
              />
            )}
          </Info>
        </el-card>
        {!this.readonly && (
          <DataTable
            data={this.data.items}
            style={{ marginTop: '1.5rem' }}
            onChange={value => {
              this.emit('items', value)
            }}
          />
        )}
        {(!this.readonly || (this.readonly && this.data.note)) && <Note />}
      </div>
    )
  }
}
</script>
